 
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const suRoutes: RouteObject[] = [
  {
    path: 'SU/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/SU/DashBoard/SuDahboard.jsx')) },

      // Contracts
      { path: 'Contracts', lazy: lazyRoute(() => import('../../pages/SU/Contracts/index/Contracts.jsx')) },
      { path: 'Contracts/AddContracts', lazy: lazyRoute(() => import('../../pages/SU/Contracts/Add/AddContracts.jsx')) },
      { path: 'Contracts/:id/UpdateContract', lazy: lazyRoute(() => import('../../pages/SU/Contracts/Update/UpdateContract.jsx')) },

      // Real Estate
      { path: 'RealEstate', lazy: lazyRoute(() => import('../../pages/SU/RealEstate/index/RealEstate')) },
      { path: 'RealEstate/AddRealEstate', lazy: lazyRoute(() => import('@pages/SU/RealEstate/Add/AddRealEstate.jsx')) },
      { path: 'RealEstate/:Id/UpdateRealEstate', lazy: lazyRoute(() => import('../../pages/SU/RealEstate/Update/UpdateRealEstate.jsx')) },
      {
        path: 'RealEstate/:RealEstateId/ExtraRecordRealEstate',
        lazy: lazyRoute(() => import('../../pages/SU/RealEstate/ExtraRecord/ExtraRecordRealEstate'))
      },
      { path: 'RealEstate/:Id/Accomodation', lazy: lazyRoute(() => import('../../pages/SU/RealEstate/Accomodation/Accomodation')) },

      // Follow Payments
      { path: 'FollowPayments/InstallmentUnPayment', lazy: lazyRoute(() => import('../../pages/SU/FollowPayments/InstallmentUnPayment/InstallmentUnPaymentList')) },
      { path: 'FollowPayments/InstallmentPayment', lazy: lazyRoute(() => import('../../pages/SU/FollowPayments/InstallmentPayment/InstallmentPaymentList')) },

      // Extra Information Dynamic Type
      { path: 'SU_ExtraInformationDynamicType', lazy: lazyRoute(() => import('../../pages/SU/ExtraInformationDynamicType/SU_ExtraInformationDynamicType.jsx')) },
      {
        path: 'SU_ExtraInformationDynamicType/:FormId/Edit',
        lazy: lazyRoute(() =>
          import('../../pages/NTX/FlexValue/ExtraInformationDynamicType/EditExtraInformationDynamicType.jsx')
        )
      },

      // Owners / Tenants
      { path: 'Owners', lazy: lazyRoute(() => import('../../pages/SU/Owners/Index')) },
      { path: 'Tenants', lazy: lazyRoute(() => import('../../pages/SU/Tenants/Index')) },

      // Maintenance Orders
      { path: 'MaintenanceOrders', lazy: lazyRoute(() => import('../../pages/SU/MaintenanceOrders/Index')) },
      { path: 'MaintenanceOrders/AddOrder', lazy: lazyRoute(() => import('../../pages/SU/MaintenanceOrders/Add')) },

      // Reports
      { path: 'Reports', lazy: lazyRoute(() => import('../../pages/SU/SUReports/SUReports')) },
      {
        path: 'Reports/:ReportId/ReportsBuilder',
        lazy: lazyRoute(() =>
          import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder')
        )
      }
    ]
  },

  // Settings (outside SU/*)
  { path: 'SUSettings/Branches', lazy: lazyRoute(() => import('../../pages/SU/Branches/Index')) },
  { path: 'SUSettings/Branches/:id/Edit', lazy: lazyRoute(() => import('../../pages/SU/Branches/UpdateBranches')) },

  { path: 'SUSettings/Locations', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Locations/Index')) },
  { path: 'SUSettings/Locations/:id/Edit', lazy: lazyRoute(() => import('../../pages/FLEET/FleetSettings/Locations/UppdateLocations')) }
];

export default suRoutes;
